import { Component, Input } from '@angular/core';
import { Invoice } from '@flashvpn-io/web-core';

@Component({
  selector: 'app-recharge-record',
  templateUrl: './recharge-record.component.html',
  styleUrl: './recharge-record.component.css'
})
export class RechargeRecordComponent {
  @Input() showAll: boolean = false;
  @Input() invoices: Invoice[] = [];
  @Input() isLoading: boolean = false;

  private imageMap = [
    'assets/images/gift.png',
    'assets/images/sweden_gift.png',
    'assets/images/red_gift.png'
  ];

  private getImage(p: string) {
    switch (p) {
      case '50':
        return 'assets/images/gift-3.png';
      case '20':
        return 'assets/images/gift-2.png';
      default:
        return 'assets/images/gift-1.png';
    }
  }

  get displayedRecords() {
    if (!this.invoices || this.invoices.length === 0) {
      return [];
    }

    const mappedRecords = this.invoices.map((invoice, index) => ({
      image: this.getImage((invoice.description.match(/\d{2}/) || ['10'])[0]),
      name: invoice.description,
      time: invoice.datepaid,
      paid: invoice.status === 'Paid',
      price: invoice.total.toString()
    }));

    return this.showAll ? mappedRecords : mappedRecords.slice(0, 3);
  }

  get shouldShowNoRecords(): boolean {
    return !this.isLoading && (!this.invoices || this.invoices.length === 0);
  }
} 